<template>
    <component :is="href ? 'a' : 'router-link'" v-bind="href ? { href, target } : { to }" class="flex h-full items-center justify-center gap-x-1.5 border-t-2"
                 :class="[active ? 'bg-white text-next-orange font-bold border-next-orange':'border-next-neu text-next-gray-md hover:text-white hover:border-next-dark-gray hover:bg-next-dark-gray duration-300']">
        <i :class="iconClass"></i>
        <span><slot></slot></span>
    </component>
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';

@Options({
    name:'TopNavigationButton',
    props: {
        active: Boolean,
        iconClass: String,
        to: Object,
        href: String,
        target: String,
    }
})
export default class TopNavigationButton extends Vue {
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
